<template>
  <HeaderTrade/> 
  <!-- Container Start { -->
  <div id="container">
    <!-- Contents Start { -->
    <div id="contents">

      <!-- content start -->
      <div class="contents-area">

        <div class="top-nav-tab">
          <ul>
            <li><router-link :to="{ name: 'Notice'}" class="active">공지사항</router-link></li>
            <li><a href="javascript:;" @click="onQna">1:1문의</a></li>
          </ul>
        </div>

        <div class="bbs-list-inner">
          <div class="list-title-select">
            <select class="form-select" aria-label="select" @change="onSelectChange">
              <option value="5" selected>5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="30">30</option>
              <option value="40">40</option>
              <option value="50">50</option>
            </select>
          </div>

          <!-- 공지사항 리스트 start -->
          <div class="bbs-list-li">
            <ul>
              <li
                v-for="(item, index) in boardList"
                :key = index            
              >
                <router-link :to="{ name:'NoticeView',  params:{ id:item.IDX }}"  class="link">
                  <p class="txt text-truncate">
                    {{item.SUBJECT}}
                  </p>
                  <span class="writer text-truncate">FLEXMONEY</span>
                  <span class="date">{{item.CREATIONDATE.split(' ')[0].replaceAll('-','.')}}</span>
                </router-link>       
              </li>
            </ul>
          </div>
          <div v-if="!boardList.length" class="bbs-list-none">공지사항글이 없습니다.</div>

        </div>

        <!-- 검색 영역 / 글쓰기 버튼 start -->
        <div class="bbs-list-control">
          <select class="form-select" v-model="srchType">
            <option value="search_like" selected="selected">제목+내용</option>
            <option value="subject_like">제목</option>
            <option value="contents_like">내용</option>
          </select>
          <div class="control-search">
            <input type="text" class="form-control" aria-label="search" id="inputSearch" placeholder="검색어를 입력하세요." v-model="srchKeyword" @keyup.enter="srchCommunity">
            <button class="btn-search" type="button"><img src="@/assets/images/common/ico_search.png" alt="search" @click="srchCommunity"></button>
          </div>
        </div>
        <!-- //검색 영역 / 글쓰기 버튼 end -->

        <!-- 페이징 start-->
        <div class="section paging-area" v-if="boardList.length">
           <v-pagination                  
                v-model="currentPage"
                :pages= numberOfPages
                :rangeSize="1"  
                @update:modelValue="updateHandler(currentPage, categoryType, categoryCode)"
            />          


        </div>
        <!-- //페이징 end -->        

      </div>
      <!-- //content end -->  

    </div>
    <!-- } Contents End -->

  </div>
  <!-- } Container End -->
  <Footer/>
</template>

<script>
import { useStore } from 'vuex';
import { useRouter }from 'vue-router'
import { ref, onMounted, computed, getCurrentInstance, onUnmounted } from 'vue';
import { useApicall } from '@/composables/commonFn';
import HeaderTrade from '@/components/HeaderTrade.vue';
import Footer from '@/components/Footer.vue';

import VPagination from "@hennge/vue3-pagination";
import '@/assets/css/vue3-pagination.css';
export default {
  components: {  
    HeaderTrade, 
    Footer,
    VPagination
  },

  setup() {
    const store = useStore();
    const router = useRouter();
    const emitter = getCurrentInstance().appContext.config.globalProperties.emitter;
    store.commit('trade/CHANGE_CURRENT_PAGE_ID', 'navi_notice'); 
    store.commit('common/CHANGE_CURRENT_PAGE', 'Notice');    
    const boardList = ref([]);
    const limit = ref(5);
    const currentPage = ref(1);
    const numberOfData = ref(0);
    const numberOfPages = computed(()=>{
      return Math.ceil(numberOfData.value/limit.value)
    });
    const { apiCall_g } = useApicall();

    const categoryType = ref('aboard');
    const categoryCode = ref('notice');
    const noticeList = ref([]);
    const isLogin = computed(() => store.state.user.isLogin);
    const currentPage_store = computed(() => store.state.common.noticeCurrentPage);
    const page_store = computed(() => store.state.common.currentPage);

    const srchType = ref('search_like');
    const srchKeyword = ref('');

    onMounted( async() => {        
      emitter.emit('EVENT_CHECK_LOGIN');  
      updateHandler(currentPage_store.value, categoryType.value, categoryCode.value);
    })

    const updateHandler = (e,  _cType, _cCode) => {
      getDataList(e, _cType, _cCode);
    }

    const getDataList  = async( page = currentPage.value, categoryType, categoryCode ) =>{    
      currentPage.value = page; 
      store.commit('common/CHANGE_NOTICE_CURRENT_PAGE', page);

      var offset = (currentPage.value -1)*limit.value;
      var getUrl = `board/list?limit=${limit.value}&offset=${offset}&categoryType=${categoryType}&categoryCode=${categoryCode}`;

      if( srchKeyword.value ) {
        var addurl = `&${srchType.value}=${srchKeyword.value}`;
        getUrl += addurl;
      }

      var boardDataList = await apiCall_g(getUrl)

      try {
        if(boardDataList.dataList == null) boardDataList.dataList = [];
        boardList.value = boardDataList.dataList;
        numberOfData.value = boardDataList.dataCount;
      } catch (error) {
        boardList.value = [];
        numberOfData.value  = 0;
      }
    }

    const onSelectChange = (e) => {
      limit.value = e.target.value;
      updateHandler(1, categoryType.value, categoryCode.value)
    }

    const srchCommunity = () => {
      updateHandler(1, categoryType.value, categoryCode.value);
    }

    const onQna = ()=>{
      if(isLogin.value) {
        router.push({
          name: 'Qna',
        });
      } else {
        emitter.emit('EVENT_ALERT',{title:"알림", body:"로그인 후 이용 가능합니다."});
      }
    }    

    onUnmounted(()=> {     
      if(page_store.value !== 'Notice') {
        store.commit('common/CHANGE_NOTICE_CURRENT_PAGE', 1);
      }
    })

    return {      
      isLogin,
      numberOfPages,
      boardList,
      currentPage, 
      updateHandler,
      onSelectChange,
      categoryType,
      categoryCode,
      noticeList,
      srchType,
      srchKeyword,
      srchCommunity,
      onQna,
      page_store,
    }
  }
}
</script>

<style>

</style>